import { useDisclosure } from "@chakra-ui/react";
import Form from '@rjsf/core';
import { useContext, useState } from "react";
import Dialog from "../../../components/dialog/Dialog";
import { lang } from "../../../Utils"
import { getForms } from "../Services";
import { FeatureContext } from '../../../Context';
import DropZone from "../../../components/dropzone/DropZone";
import { Button } from "../../../components/button/Button";
const Create = () => {

  const context = useContext(FeatureContext);

  const { isOpen: isOpenForm, onOpen: onOpenForm, onClose: onCloseForm } = useDisclosure();
  const [form, setForm] = useState();
 
  const onClick = () => {
    getForms(context.message.form)
      .then(data => {
        if (context.message.attachment !== 'no') {
          data.frmschema.properties['file'] = { type: 'string', format: "data-url", title: 'File' };
          data.uischema = {
            ...data.uischema, 
            file: {
              'ui:widget' : 'dropZone'
            }
          };
          data.uischema['ui:order'].push('file');
        }
        Object.entries(data.frmschema.properties).forEach(el => 
          data.frmschema.properties[el[0]].title = lang(el[1].title)
        );
        setForm(data);
        onOpenForm();
      })
  }

  const onFormSubmit = ({ formData }, e) => {
    context.onFormSubmit({
      ...formData,
      filter1: context.topic.value,
      filter2: context.field.value,
      filter3: context.assets.value
    });
    onCloseForm();
  }

  return (<>
    <button type="button" onClick={onClick}>{lang('Contact Us')}</button>
    <Dialog title={lang("Contact Us")} isOpen={isOpenForm} onClose={onCloseForm}>
      <Form
        className="bf-enquiry-form"
        schema={form?.frmschema}
        uiSchema={form?.uischema}
        onSubmit={onFormSubmit}
        widgets={{dropZone: DropZone}}>
        <div className="bf-enquiry-form-action">
          <Button type="submit">{lang('Submit')}</Button>
        </div>
      </Form>
    </Dialog>
  </>)
}

export default Create;